import React from "react";

import Checkbox from "ds/Checkbox";
import { useFeatureFlagToggle } from "Reducers/featureFlags/useFeatureFlagToggle";

import * as S from "../TestingModal.styles";

const InteralSericeMetricsFlag = () => {
  const [enabled, setEnabled] = useFeatureFlagToggle(
    "ENABLE_INTERNAL_SERVICE_METRICS"
  );

  return (
    <S.CheckboxWrapper>
      <Checkbox
        checked={enabled}
        onCheckedChanged={() => setEnabled(!enabled)}
        label="Internal Service Metrics"
        forId="internal_service_metrics"
      />
    </S.CheckboxWrapper>
  );
};

export default InteralSericeMetricsFlag;
